import ReactDOM from 'react-dom';
import VistaPreviaPresupuestoPDF from './VistaPreviaPresupuestoPDF';

/** Ancho útil carta vertical (~215.9mm − márgenes html2pdf). */
export const PRESUPUESTO_PDF_WIDTH_MM = 190;

export const getPresupuestoHtml2PdfOptions = (numeroPresupuesto) => ({
    margin: 10,
    filename: `presupuesto-${numeroPresupuesto}.pdf`,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: {
        scale: 2,
        useCORS: true,
        logging: false,
        letterRendering: true,
        scrollX: 0,
        scrollY: 0,
        /** Evita capturar el ancho del viewport y recortar columnas a la derecha. */
        windowWidth: Math.round((PRESUPUESTO_PDF_WIDTH_MM / 25.4) * 96),
    },
    jsPDF: {
        unit: 'mm',
        format: 'letter',
        orientation: 'portrait',
        compress: true,
    },
    pagebreak: {
        mode: ['css', 'legacy'],
    },
});

/**
 * Renderiza el layout optimizado para PDF fuera de pantalla y descarga el archivo.
 */
export const descargarPresupuestoPdf = async ({
    presupuesto,
    client,
    paciente,
    encabezadoPersonalizado,
    usuario,
}) => {
    const contenedorTemporal = document.createElement('div');
    contenedorTemporal.style.cssText = 'position:absolute;left:-9999px;top:0;overflow:visible;';
    document.body.appendChild(contenedorTemporal);

    try {
        ReactDOM.render(
            <VistaPreviaPresupuestoPDF
                presupuesto={presupuesto}
                client={client}
                paciente={paciente}
                encabezadoPersonalizado={encabezadoPersonalizado}
                usuario={usuario}
            />,
            contenedorTemporal
        );

        await new Promise((resolve) => setTimeout(resolve, 350));

        const element = document.getElementById('presupuesto-pdf-editable');
        if (!element) {
            throw new Error('No se encontró el contenido del presupuesto para PDF');
        }

        const html2pdf = await import('html2pdf-fix-jspdf');
        const opt = getPresupuestoHtml2PdfOptions(presupuesto.numero_presupuesto);
        await html2pdf.default().from(element).set(opt).save();
    } finally {
        ReactDOM.unmountComponentAtNode(contenedorTemporal);
        if (document.body.contains(contenedorTemporal)) {
            document.body.removeChild(contenedorTemporal);
        }
    }
};
